"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReopenCookiePreferences = exports.HASH_FOR_COOKIE_PREFERENCES = void 0;
var _react = require("react");
/* istanbul ignore file -- one trust */

const HASH_FOR_COOKIE_PREFERENCES = exports.HASH_FOR_COOKIE_PREFERENCES = '#cookie-preferences';
const useReopenCookiePreferences = () => (0, _react.useEffect)(() => {
  const onClick = event => {
    if (event.target instanceof HTMLAnchorElement && event.target.hash === HASH_FOR_COOKIE_PREFERENCES) {
      event.preventDefault();
      // eslint-disable-next-line new-cap -- OneTrust API
      window.OneTrust?.ToggleInfoDisplay();
    }
  };
  document.addEventListener('click', onClick);
  return () => document.removeEventListener('click', onClick);
}, []);
exports.useReopenCookiePreferences = useReopenCookiePreferences;
